module.exports = __webpack_public_path__ + "img/ballantines-logo.4f183d27.svg";